import React from 'react'
import PropTypes from 'prop-types'

const Spinner = ({colorIcon, centered, small}) => {  

  const classNameSpinner = `common-spinner spinner-border ${
    (centered ? 'centered' : '')
    + (small ? ' small' : '')
  }`
  return (
    <div className={classNameSpinner} role="status" style={{color: colorIcon || '#2b2b2b'}}>
      <span className="sr-only">Cargando...</span>
    </div>
  )
}

Spinner.propTypes = {
  colorIcon: PropTypes.string,
  centered: PropTypes.bool,
  small: PropTypes.bool,
}

export default Spinner